module.exports = __webpack_public_path__ + "img/logo_meiwei.c1fb0be8.png";